import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  width: "24",
  height: "24",
  viewBox: "0 0 26.1 26"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M23.9 11.1c-1.1-6-6.9-10-12.8-8.9C5.1 3.3 1.1 9 2.2 15S9 24.9 15 23.8c6-1 10-6.7 8.9-12.7M10.8.2C17.9-1.1 24.7 3.7 26 10.7c1.3 7.1-3.5 13.9-10.5 15-7.2 1.4-14-3.2-15.3-10.3S3.7 1.5 10.8.2",
  style: {"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#0000e7"}
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12.1 1.7C5.8 2.4 1.2 7.8 1.7 14.1c.6 6.3 6 10.8 12.3 10.3 6.3-.6 10.8-6 10.3-12.3-.5-6.2-6-10.9-12.2-10.4M11.9.4C19-.2 25 5 25.7 11.9c.6 7-4.5 13.1-11.5 13.8-7 .6-13.1-4.5-13.8-11.5C-.2 7.2 4.9 1.1 11.9.4",
  style: {"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#0000e7"}
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M6 2.5c.3-.2.8-.1 1 .2l1.9 2.9c.1.4 0 .8-.3 1s-.7.1-.9-.2l-1.9-3c-.2-.3-.1-.7.2-.9M17.5 19.6c.3-.2.7-.1.9.2l1.9 2.9c.2.3.1.7-.2.9s-.7.1-.9-.2l-1.9-2.9c-.2-.3-.1-.7.2-.9M12.3 9.7c-.7 0-1.2.5-1.2 1.2 0 .6.4 1 .8 1.1h.1l2.5.7c1.2.3 2 1.4 2 2.5 0 1.4-1.1 2.5-2.5 2.5h-1.5c-1 0-1.7-.6-2.1-1.2-.2-.3-.2-.7.1-.9s.7-.2.9.1c.3.4.7.7 1.1.7H14c.7 0 1.2-.5 1.2-1.2 0-.5-.3-1-1-1.2l-2.5-.7c-1.2-.2-1.9-1.4-1.9-2.4 0-1.4 1.1-2.5 2.5-2.5h1.5c.9 0 1.8.5 2.2 1.3.2.3 0 .7-.3.9s-.7 0-.9-.3c-.1-.3-.6-.6-1-.6z",
  style: {"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#0000e7"}
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "M13.1 7.1c.4 0 .7.3.7.7v1.3c0 .4-.3.7-.7.7s-.7-.3-.7-.7V7.7c0-.3.3-.6.7-.6M13.1 16.4c.4 0 .7.3.7.7v1.3c0 .4-.3.7-.7.7s-.7-.3-.7-.7v-1.3c0-.4.3-.7.7-.7",
  style: {"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#0000e7"}
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }